import React from "react";
import Button from "@material-ui/core/Button";
import PaymentIcon from '@material-ui/icons/Payment';
import { useTranslation } from 'react-i18next';

const BotonAuthorize = props => {
  const { muestra, deshabilita, errorDestinoNotifica, pagoEnProgreso, identificador, llave, urlEmbebido } = props;
  const { t } = useTranslation(['translation', 'pagos']);

  const existeAuthorize = document.getElementById('scriptAuthorize');
  var cargarScript = !(identificador == null || llave == null || urlEmbebido == null);


  if (!existeAuthorize && cargarScript) {
    console.log('cargo script');
    const script = document.createElement('script');
    script.src = urlEmbebido;

    script.id = "scriptAuthorize"
    document.body.appendChild(script);
  }

  return (
    <Button
      id="btnPayment"
      endIcon={<PaymentIcon />}
      style={{ display: muestra }}
      disabled={deshabilita || (errorDestinoNotifica !== '') || pagoEnProgreso}
      color="primary"
      variant="contained"
      autoFocus
      className={"AcceptUI"}
      data-apiloginid={identificador}
      data-clientkey={llave}
      data-acceptuiformbtntxt={"Confirm"}
      data-acceptuiformheadertxt={"Credit card information (Note: We do not save your data)"}
      data-responsehandler={"responseHandler"}
    >
      {t('pagos:botonpagar')}
    </Button>
  );
};

export default BotonAuthorize;
